import { getHeaderNavLinks } from "../../../constants";
import { HeaderNavLink } from "../HeaderNavLink";
import styles from "./styles.module.css";

export const HeaderNav = () => {
  const headerNavLinks = getHeaderNavLinks();

  return (
    <div className={styles.container}>
      {headerNavLinks.map(({ path, title }, index) => (
        <HeaderNavLink key={index} to={path} title={title} />
      ))}
    </div>
  );
};
